import SurveyHeader from "./SurveyHeader";
import Questions from "./Questions";
import SurveyScore from "./SurveyScore";
import Typography from "@material-ui/core/Typography";
import React, {useEffect, useState} from "react";
import request from "../../../../../../Services/API/Requests";
import JsonScreenHoc from "../../../../../../HocHelpers/JsonScreenHoc";
import {getParamsFromString} from "../../../../Utils";

function generateStyles(styles) {
    if (styles && styles.length) {
        return {
            header: styles[0] || {},
            body: styles[1] || {},
            footer: styles[2] || {}
        }
    }
    return {
        header: {},
        body: {},
        footer: {}
    }
}

const PlayerMode = ({ surveyId, dataSource, styles: sourceStyles, showScoring, globalValues, screenName }) => {
    const [survey, setSurvey] = useState({});
    const [loading, setLoading] = useState(false);
    const styles = generateStyles(sourceStyles);
    const executedSurveyId = getParamsFromString(surveyId, globalValues, screenName);
    useEffect(() => {
        async function fetchSurvey() {
            setLoading(true);
            if (executedSurveyId && dataSource) {
                try {
                    const response = await request({
                        method: "POST",
                        url: "/surveyParam/read",
                        data: {id: executedSurveyId}
                    });
                    setLoading(false);
                    setSurvey(response);
                    return
                } catch (e) {
                    console.log(e);
                    setLoading(false);
                }
            }
            setLoading(false)
        }

        fetchSurvey();
    }, [executedSurveyId]);
    return (
        <div style={{border: '1px solid rgba(0, 0, 0, 0.12)', width: '100%'}}>
            {surveyId && dataSource ? (
                <>
                    <SurveyHeader
                        title={survey.name}
                        styles={styles.header}
                        loading={loading}
                    />
                    <Questions
                        styles={styles.body}
                        questions={survey.questions}
                        fieldName={dataSource}
                        loading={loading}
                    />
                    <SurveyScore
                        styles={styles.footer}
                        showScoring={survey.type === 'scoring'}
                        fieldName={dataSource}
                        questions={survey.questions}
                        loading={loading}
                    />
                </>
            ) : (
                <div style={{height: 50, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    <Typography color={"textSecondary"}>
                        Survey Id or Data Source is not defined
                    </Typography>
                </div>
            )}

        </div>
    )
}
export default JsonScreenHoc(PlayerMode)